module.exports = __webpack_public_path__ + "a214fa4d523f8fdf62ab18f87132755b.png";